import { Strings } from '@/constants/strings';

interface ToggleRowProps {
  label: string;
  value: boolean | null;
  onValueChange: (value: boolean) => void;
  showInfoIcon?: boolean;
  onInfoPress?: () => void;
}

export function ToggleRow({
  label,
  value,
  onValueChange,
  showInfoIcon,
  onInfoPress,
}: ToggleRowProps) {
  return (
    <div className="mb-5">
      <div className="mb-2 flex items-center gap-1.5">
        <span className="text-[15px] font-medium text-text-heading">{label}</span>
        {showInfoIcon && (
          <button
            type="button"
            onClick={onInfoPress}
            className="rounded px-1 py-0.5 text-base font-bold text-primary hover:bg-primary/6 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1"
            aria-label="Bilgi"
          >
            (?)
          </button>
        )}
      </div>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => onValueChange(true)}
          className={`flex-1 rounded-lg border-2 py-3 text-center text-base font-medium transition
            ${value === true ? 'border-primary bg-primary/8 text-primary' : 'border-border bg-white text-[#5C5C5C]'}
          `}
        >
          {Strings.yes}
        </button>
        <button
          type="button"
          onClick={() => onValueChange(false)}
          className={`flex-1 min-h-[48px] rounded-xl border-2 py-3.5 text-center text-base font-medium transition
            ${value === false ? 'border-primary bg-primary/10 text-primary' : 'border-slate-200 bg-card-bg text-text-muted'}
          `}
        >
          {Strings.no}
        </button>
      </div>
    </div>
  );
}
